import { EmpathizeLayout, EmpathizeLayoutState, EmpathizeState, EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class LayoutGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.layout]: (empathizeState: EmpathizeState, getters: any, rootState: RootStoreState,
      rootGetters: any): EmpathizeLayout => {
      const config: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const empathizeDetectedState: EmpathizeLayoutState = getters[EMPATHIZE_GETTERS_KEYS.empathizeDetectedState];
      return config.empathize.layout[empathizeDetectedState];
    }
  };
}
